import { render, staticRenderFns } from "./CurriculumSendButton.vue?vue&type=template&id=e37879f2&scoped=true&lang=pug"
import script from "./CurriculumSendButton.vue?vue&type=script&lang=js"
export * from "./CurriculumSendButton.vue?vue&type=script&lang=js"
import style0 from "./CurriculumSendButton.vue?vue&type=style&index=0&id=e37879f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37879f2",
  null
  
)

export default component.exports